module.exports = __webpack_public_path__ + "static/cinsa_servicio_mantenimiento-5300f13c8900976a507aa5cd6e4b898d.jpg";